import store from "redux/store/index";

const FeatureFlags = {
  getFlags: () => {
    var flags = store.getState().flags;
    return flags;
  },
  isEnabled: (feature) => {
    var flags = FeatureFlags.getFlags();
    return flags.includes(feature);
  },
  FLAGS: {
    DEFAULT: 'DEFAULT',
    DEV: 'DEV',
    CLEAR_MA_CACHE: 'CLEAR_MA_CACHE',
    MILLISECOND_RESOLUTION: 'MILLISECOND_RESOLUTION',
    SECOND_RESOLUTION: 'SECOND_RESOLUTION',
    DATA_TAGGING: 'DATA_TAGGING',
    RETENTION_1_YEAR: 'RETENTION_1_YEAR',
    RETENTION_2_YEAR: 'RETENTION_2_YEAR'
  }
}

export { FeatureFlags }



// WEBPACK FOOTER //
// ./src/services/FeatureFlagsService.jsx